import { makeStyles } from "@material-ui/core/styles";

const usePickPlanModalStyles = makeStyles(() => ({
  modalWrapper: {
    backgroundColor: "#1B1D28",
    padding: "20px",
    color: "#ffffff",
    borderRadius: "8px",
    minWidth: "300px",
  },

  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },

  plansWrapper: {
    marginTop: "20px",
    display: "flex",
    gap: "15px",
  },

  planCard: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    padding: "16px",
    gap: "18px",
    width: "279px",
    height: "400px",
    background:
      "radial-gradient(68.46% 100% at 50.11% 100%, rgba(108, 101, 217, 0.1) 0%, rgba(108, 101, 217, 0) 100%), rgba(0, 0, 0, 0.3)",
    borderRadius: "10px",
  },

  planContent: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    flexGrow: 1,
  },

  subtitle: {
    fontFamily: "Poppins",
    fontSize: "13px",
    height: "40px",
    color: "#B1B5C9",
  },

  titleWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    paddingBottom: "8px",
  },

  planTitle: {
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: "24px",
    lineHeight: "36px",
    color: "#F9F9F9",
  },

  price: {
    fontFamily: "Poppins",
    fontSize: "18px",
    lineHeight: "27px",
    color: "#606479",
  },

  featureList: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },

  featureItem: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },

  checkIcon: {
    width: "21px",
    height: "21px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  featureText: {
    fontFamily: "Poppins",
    fontSize: "14px",
    lineHeight: "21px",
    color: "#ECECEC",
  },

  chooseButton: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px 20px",
    gap: "10px",
    width: "247px",
    height: "41px",
    border: "2px solid #6C65D9",
    borderRadius: "10px",
    textTransform: "none",
    color: "#F9F9F9",
    backgroundColor: "#6C65D9",

    "&:hover": {
      backgroundColor: "#6C65D9",
    },
  },

  currentPlanButton: {
    backgroundColor: "transparent",
  },
}));

export default usePickPlanModalStyles;
